import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { Grid, Select } from 'semantic-ui-react';
import { withRouter } from 'react-router';
import { LANGUAGE_SETUP_FORM_NAME } from 'Common/FormEnum';
import { Filter, Main } from 'Containers';
import { getIsDirty } from 'Common/Selectors/DirtySelector';
import {
  getLanguages,
  getLanguageFields,
  writeLanguageFields,
  setLanguage,
  resetSuccess,
} from './state/actions';
import { LanguageSetupForm } from './components/LanguageSetupForm';
import { DirtyWrapper } from 'Components';
import { createToast, toastType, errorToast } from 'Common/ToastHelper';
import { resetDirty } from 'State/dirtyTracking/actions';
import { submitDelay } from 'Common/GeneralHelper';

class LanguageSetupContainer extends Component {
  state = {
    selectedLanguage: 1,
  };

  componentDidMount() {
    this.props.getLanguages();
    this.props.getLanguageFields(this.state.selectedLanguage);
  }

  componentDidUpdate(prevProps) {
    errorToast(this.props, prevProps, 'fetchError');

    if (this.props.success === 1) {
      createToast(toastType.success, null, 'Save successful.', true, 2500);
      this.props.resetSuccess();
      this.props.resetDirty();
    }
  }

  submitForm = values => {
    return submitDelay().then(() => {
      this.props.writeLanguageFields(values);
    });
  };

  confirmChange = () => {
    const { selectedLanguage } = this.state;

    this.props.setLanguage(selectedLanguage);
    this.props.getLanguageFields(selectedLanguage);
  };

  getMainProps = () => {
    const { isReadOnly } = this.props;

    return {
      toolbox: {
        isReadOnly,
        formName: LANGUAGE_SETUP_FORM_NAME,
        shown: true,
      },
    };
  };

  render() {
    const options = this.props.languageList.map(element => {
      return {
        value: element.Id,
        text: element.Description,
      };
    });

    return (
      <Fragment>
        <Filter title="Language Setup" />
        <Main {...this.getMainProps()}>
          <Grid>
            <Grid.Row columns={4}>
              <Grid.Column>
                <div className="card-indent">
                  <label className="text-orange">Language</label>
                  <DirtyWrapper closeModalYesCallback={this.confirmChange}>
                    {showDirtyConfirm => (
                      <Select
                        fluid
                        options={options}
                        onChange={(e, data) => {
                          this.setState(
                            {
                              selectedLanguage: data.value,
                            },
                            showDirtyConfirm
                          );
                        }}
                        value={this.props.selectedLanguage}
                        disabled={this.props.isFetching}
                      />
                    )}
                  </DirtyWrapper>
                </div>
              </Grid.Column>
            </Grid.Row>
          </Grid>
          <LanguageSetupForm
            onSubmit={this.submitForm}
            initialValues={this.props.languageFields}
            isFetching={this.props.isFetching}
            isReadOnly={this.props.isReadOnly}
          />
        </Main>
      </Fragment>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  ownProps.setPageLevelDirty(getIsDirty(LANGUAGE_SETUP_FORM_NAME)(state));
  return {
    languageList: state.LanguageSetupState.languages,
    languageFields: state.LanguageSetupState.languageFields,
    isFetching: state.LanguageSetupState.isFetching,
    fetchError: state.LanguageSetupState.fetchError,
    selectedLanguage: state.LanguageSetupState.selectedLanguage,
    success: state.LanguageSetupState.success,
  };
};

export const LanguageSetup = withRouter(
  connect(
    mapStateToProps,
    {
      getLanguages,
      getLanguageFields,
      writeLanguageFields,
      setLanguage,
      resetDirty,
      resetSuccess,
    }
  )(LanguageSetupContainer)
);



// WEBPACK FOOTER //
// ./src/pages/languagesetup/LanguageSetup.js